import React, { useEffect } from "react";
import { Form, InputNumber, Typography } from "antd";
import { elvis } from "../../Utils"

const { Title } = Typography;

const ProvisionForm = props => {
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        value: props.record.asset.value
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        value: props.record.asset.value
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;
    
    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);
    
    const newAsset = { ...props.record };
    newAsset.asset.value = elvis(values.value);
    newAsset.valid = isValid;
    props.parentCallback(newAsset);
  };

  return (
    <Form 
      form={form}
      {...formItemLayout} 
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title 
        className="details_form_header"
        title="Asset details"
        subTitle="Provision"
      />
      
      <Form.Item 
        label="Value (€)" 
        name="value"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default ProvisionForm;